import { Message, Segment } from 'semantic-ui-react';
import styled from 'styled-components';
import Loading from './Loading';

const CustomMessage = styled(Message)`
	white-space: pre-line;
`;

function Errors({ errors, show_date, loading }) {
	if(!errors.length) {
		return <Message positive>All tests passed!</Message>
	}

	if(loading) {
		return <Loading />
	}

	return (
		<>
			{errors.map((error, i) => {
				return (
					<Segment key={i}>
						{show_date &&
							<p>{error.run_date}</p>
						}
						<p>{error.title}</p>
						<Message negative>{error.message}</Message>
						<CustomMessage negative>{error.stacktrace}</CustomMessage>
					</Segment>
				)
			})}
		</>
	)
}

export default Errors;
